import React from "react";
import { Chip } from "@mui/material";
import { AutorenewIcon, CheckCircleIcon, ErrorIcon, HourglassEmptyIcon, PauseCircleIcon, PlayCircleIcon, RemoveCircleOutlineIcon, WarningIcon } from "../../icons";
type ChipColor = "default" | "primary" | "success" | "warning" | "error" | "info";

/** Única fuente de verdad: status (WorkerEvent/BotRun/sesión/salud) → color+icono+label. */
const STATUS_MAP: Record<string, { color: ChipColor; icon: React.ReactElement; label?: string }> = {
  // WorkerEvent
  queued: { color: "info", icon: <HourglassEmptyIcon />, label: "en cola" },
  processing: { color: "primary", icon: <AutorenewIcon />, label: "procesando" },
  completed: { color: "success", icon: <CheckCircleIcon />, label: "completado" },
  failed: { color: "error", icon: <ErrorIcon />, label: "falló" },
  dead_letter: { color: "error", icon: <ErrorIcon />, label: "agotó reintentos" },
  waiting: { color: "warning", icon: <PauseCircleIcon />, label: "esperando (gate)" },
  superseded: { color: "default", icon: <RemoveCircleOutlineIcon />, label: "reemplazado" },
  // BotRun
  pending: { color: "info", icon: <HourglassEmptyIcon />, label: "pendiente" },
  running: { color: "primary", icon: <PlayCircleIcon />, label: "ejecutando" },
  requires_intervention: { color: "error", icon: <WarningIcon />, label: "requiere intervención" },
  cancelled: { color: "default", icon: <RemoveCircleOutlineIcon />, label: "cancelado" },
  // SimulationSession
  aborted: { color: "default", icon: <RemoveCircleOutlineIcon />, label: "abortada" },
  // Salud (tablero)
  deadEnd: { color: "error", icon: <WarningIcon />, label: "requiere intervención" },
  recovering: { color: "warning", icon: <AutorenewIcon />, label: "auto-recuperando" },
  inProgress: { color: "primary", icon: <PlayCircleIcon />, label: "en curso" },
  done: { color: "success", icon: <CheckCircleIcon />, label: "completado" },
  idle: { color: "default", icon: <PauseCircleIcon />, label: "estable" },
};

export const StatusChip = ({
  status,
  size = "small",
  variant = "filled",
}: {
  status: string;
  size?: "small" | "medium";
  variant?: "filled" | "outlined";
}) => {
  const m = STATUS_MAP[status] ?? { color: "default" as ChipColor, icon: <HourglassEmptyIcon /> };
  return <Chip size={size} variant={variant} color={m.color} icon={m.icon} label={m.label ?? status} />;
};
